import { render } from "./transfert_view_tab.vue?vue&type=template&id=7cbce990"
import script from "./transfert_view_tab.vue?vue&type=script&lang=js"
export * from "./transfert_view_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__